(function(angular) {
    'use strict';

    angular.module('ui.swiper', []);
}(angular));